export default {
	headingBox: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: { xs: "flex-start", md: "center" },
		gap: 3,
		flexDirection: { xs: "column", md: "row" },
	},
	h1: {
		mt: 0,
		mb: { xs: 0.5, sm: 1 },
		fontFamily: "IvyPrestoHeadlineRegular",
		fontSize: "50px",
		lineHeight: 1.2,
		letterSpacing: "-0.02em",
		color: "#0C2728",
	},
	card: {
		border: "1px solid #b6bebf",
		borderRadius: 5,
		overflow: "hidden",
		mt: "48px",
	},
	cardHeader: {
		background: "#fff",
		p: { xs: "1rem", sm: "1.5rem" },
		color: "#0C2728",
		fontFamily: "FustatSemiBold",
		fontSize: "20px",
	},
};
